import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DialogEditVoucherComponent } from 'app/components/vouchers/edit/voucher-edit-dialog';
import { EditSampleComponent } from 'app/components/well/samples/edit/edit-samples.component';
import { RetestSearch } from 'app/models/retest/retest-search';
import { RetestService } from 'app/services/retest-service';
import { ToastrService } from 'ngx-toastr';
import { DialogEditRetestsComponent } from '../edit/retests-edit-dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '@shared/services/shared.service';
import { VoucherLetterUpload } from 'app/models/vouchers/voucher-letter-upload';
import { VoucherService } from 'app/services/voucher-service';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { BulkJob } from 'app/models/bulkJobs/bulkJob';
import { AuthService } from '@shared/auth/auth.service';

@Component({
  selector: 'app-chain-of-custody',
  templateUrl: './chain-of-custody.component.html',
  styleUrls: ['./chain-of-custody.component.scss']
})
export class ChainOfCustodyComponent implements OnInit {
  
  searchResultsCount = 0;
  letter: VoucherLetterUpload = {
    id: 0,
    letterHtml: '',
    letterType: this.voucherService.voucherCOCLetterType,
    parameterResultId: 0,
    sampleId: 0,
    voucherId: 0,
    letterContent: '',
    voucherApplicationId: 0,
    quarter: 0,
    year: 0,
    tier: 0,
    testType: '',
    testsRequired: '',
    retestId: 0,
    wellAddress: '',
    customerName: '',
    mailingAddress: '',
    mailingCity: '',
    mailingState: '',
    mailingZip: '',
    phone: '',
    email: '',
    voucherIdentifier: '',
    base64File: ''
  };

  wellAddress: string = '';
  customerName: string ="customerName";
  mailingAddress: string ="mailingAddress";
  mailingCity: string ="mailingCity";
  mailingState: string ="mailingState";
  mailingZip: string ="mailingZip";
  phone: string ="phone";
  email: string ="email";
  voucherId: string = "voucherId";

 
  constructor(public dialog: MatDialog, public sharedService: SharedService,
    public voucherService: VoucherService, public oregonWellDataService: OregonWellDataService,
    public authService: AuthService, public retestService: RetestService, private toastr: ToastrService) {
    // constructor
  }

  ngOnInit(): void {
    this.generating = false;
    if (this.searchResultsCount > 0) {
      this.onSubmit();
    }
    this.loadBulkJobs();
  }

  pageSize = 20;
  pageSizeBulkJobs = 20;
  processing = false;
  processingBulkJobs = false;
  generating = false;
  downloading = false;
  showResults = false;
  selectAll = false;
  generatingMessage = '';
  bulkJobs: BulkJob[] = [];
  bulkJob: BulkJob = {
    comments: '',
    createDate: '',
    createdBy: '',  
    failed: false,
    failedMessage: '',
    id: 0,
    jobType: '',
    modifiedby: '',
    modifiyDate: '',
    percentageComplete: 0,
    quarter: 0,
    tier: 0,
    year: 0,
    voucherLetters: [],
    wellCounty: ''
  }

  //search results
  displayedColumns: string[] = ['selectRow','id', 'wellId', 'wellCounty', 'orgininalSampleId', 'retestSampleId', 'voucherIdentifier', 'retestYear', 'retestQuarter', 'tier','dueDate', 'isComplete', 'completedDate'];
  dataSource = new MatTableDataSource<RetestSearch>();
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  filterTable(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase();
  }

  //bulk jobs
  displayedColumnsBulkJobs: string[] = ['id', 'createDate', 'modifiyDate', 'tier', 'wellCounty','year', 'quarter', 'percentageComplete', 'failed', 'message','actions'];
  dataSourceBulkJobs = new MatTableDataSource<BulkJob>();
  @ViewChild('TablePaginatorBulkJobs') paginatorBulkJobs: MatPaginator;
  @ViewChild('TableSortBulkJobs') sortBulkJobs: MatSort;

  filterTableBulkJobs(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSourceBulkJobs.filter = value.trim().toLowerCase();
  }

 
//create function to load bulk jobs
  loadBulkJobs() {
    this.processingBulkJobs = true;
    this.retestService.getBulkJobs().subscribe(
      result => {
        this.bulkJobs = result;
        this.dataSourceBulkJobs = new MatTableDataSource<BulkJob>(this.bulkJobs);
        this.dataSourceBulkJobs.paginator = this.paginatorBulkJobs;
        this.dataSourceBulkJobs.sort = this.sortBulkJobs;
        this.processingBulkJobs = false;
      },
      error => {
        this.toastr.error('Error loading Bulk Jobs');
        this.processingBulkJobs = false;
      }
    );
  }

  downloadJob(jobId: number, year: number, quarter: number, tier: number, wellCounty: string) {
    let fileName = 'ChainOfCustody_ID' + jobId.toString();
    if(year > 0){
      fileName += '_YR' + year.toString();
    }
    if(quarter > 0){
      fileName += '_Q' + quarter.toString();
    } 
    if(tier > 0){
      fileName += '_T' + tier.toString();
    }
    console.log("wellCounty", wellCounty);  
    if(wellCounty != null && wellCounty.length > 0) {
      fileName += '_' + wellCounty;
    }
    fileName += '.zip';
    this.downloading = true;
    this.retestService.downloadBulkCocJob(jobId).subscribe(
      (response) => {
        this.sharedService.downloadFile(fileName, response)
        this.downloading = false;
      },
      (error) => {
        console.log("error", error.message);
        this.downloading = false;
      }
    );
  }

  deleteBulkJob(jobId: number){
    this.sharedService.openConfirm("Are you sure you want to remove this bulk job?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.processingBulkJobs = true;
        this.retestService.deleteBulkJob(jobId).subscribe(
          result => {
            this.loadBulkJobs();
            this.toastr.success('Bulk Job Deleted');
            this.processingBulkJobs = false;
          },
          error => {
            this.toastr.error('Error deleting Bulk Job');
            this.processingBulkJobs = false;
          }
        );
      }
    });

  }

  updateAll() {

    this.dataSource.data.forEach(row => {
      row.isSelected = !this.selectAll;
    });
  }

  updateAllToFalse() {

    this.dataSource.data.forEach(row => {
      row.isSelected = false;
    });
  }

  generateCOCLetters() {
    if(this.dataSource.data.filter(x => x.isSelected).length == 0){
      this.toastr.error('No records selected');
      return;
    }
    else {

      
    this.sharedService.openConfirm("Are you sure you want to create this bulk job?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
              this.processing = true;
              this.generating = true;
              this.generatingMessage = 'Generating Letters..Please do not close this window until the process is complete. This may take a few minutes.';
              
              if(this.retestService.searchForm.value.retestYear != '' 
              && this.retestService.searchForm.value.retestYear != null) {
                this.bulkJob.year = this.retestService.searchForm.value.retestYear;
              }
              else {
                this.bulkJob.year = 0;
              }

              if(this.retestService.searchForm.value.retestQuarter != '' 
                && this.retestService.searchForm.value.retestQuarter != null) {
                this.bulkJob.quarter = this.retestService.searchForm.value.retestQuarter;
              }
              else {
                this.bulkJob.quarter = 0;
              }

              if(this.retestService.searchForm.value.tier != '' 
                && this.retestService.searchForm.value.tier != null) {
                this.bulkJob.tier = this.retestService.searchForm.value.tier;
              }
              else {
                this.bulkJob.tier = 0;
              }

              if(this.retestService.searchForm.value.wellCounty != null && this.retestService.searchForm.value.wellCounty != '') {
                this.bulkJob.wellCounty = this.retestService.searchForm.value.wellCounty;
              }
              else {
                this.bulkJob.wellCounty = '';
              }

              this.bulkJob.voucherLetters = this.dataSource.data.filter(x => x.isSelected).map(row => <VoucherLetterUpload> {
                id: 0,
                letterHtml: '',
                letterType: this.voucherService.voucherCOCLetterType,
                parameterResultId: 0,
                sampleId: +row.orgininalSampleId,
                voucherId: row.voucherId,
                letterContent: '',
                voucherApplicationId: 0,
                quarter: +row.retestQuarter,
                year: +row.retestYear,
                testsRequired:  this.retestService.nitrateOnly,
                retestId: +row.id,
                tier: +row.tier,
                testType: +row.tier == 2 ? this.retestService.testTypeQuarterly : this.retestService.testTypeAnnual,
                wellAddress: row.wellAddress,
                customerName: row.customerName,
                mailingAddress: row.mailingAddress,
                mailingCity: row.mailingCity,
                mailingState: row.mailingState,
                mailingZip: row.mailingZip,
                phone: row.phone,
                email: row.email,
                voucherIdentifier: row.voucherIdentifier
              });

              this.processing = false;
              this.generating = false;
              this.generatingMessage = '';
              this.retestService.uploadCoCLetters(this.bulkJob);
              this.toastr.success('Bulk Job Created.  View the Bulk Job tab to monitor the progress.  This may take a few minutes.');
              this.selectAll = false;
              this.updateAllToFalse();
              this.loadBulkJobs();
      }
    });
     
    }
  }



  editSample(sampleId: number) {
    const dialogRef = this.dialog.open(EditSampleComponent, {
      width: '90%',
      data: sampleId
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != "Cancel") {
        this.onSubmit();
      }
    });
  }

  editVoucher(voucherId: number) {
    const dialogRef = this.dialog.open(DialogEditVoucherComponent, {
      width: '90%',
      data: voucherId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.onSubmit();
    });
  }



  onSubmit() {
    this.setFormFields();
    this.processing = true;
    this.showResults = false;

    this.retestService.search(this.retestService.retestSearch).subscribe(
      result => {
        this.processing = false;
        this.showResults = true;
        this.retestService.searchResults = result;
        this.retestService.searchResultsCount = this.retestService.searchResults.length;
      },
      error => {
        this.processing = false;
        this.showResults = false;
      },
      () => {
        this.dataSource = new MatTableDataSource<RetestSearch>(this.retestService.searchResults);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  reset() {
    this.retestService.searchForm.reset({
      id: null,
      sampleId: null,
      voucherIdentifier: null,
      householdId: null,
      retestYear: null,
      retestQuarter: null,
      tier: null,
      isComplete: null
    });
  }

  setFormFields() {
    this.retestService.retestSearch.id = this.retestService.searchForm.value.id ?? 0;
    this.retestService.retestSearch.wellId = 0;
    this.retestService.retestSearch.orgininalSampleId = this.retestService.searchForm.value.sampleId ?? 0;
    this.retestService.retestSearch.retestSampleId = this.retestService.searchForm.value.sampleId ?? 0;
    this.retestService.retestSearch.voucherId = 0;
    this.retestService.retestSearch.voucherIdentifier = this.retestService.searchForm.value.voucherIdentifier ?? '';
    this.retestService.retestSearch.householdId = this.retestService.searchForm.value.householdId ?? 0;
    this.retestService.retestSearch.isComplete = this.retestService.searchForm.value.isComplete;
    this.retestService.retestSearch.wellCounty = this.retestService.searchForm.value.wellCounty ?? '';

    if(this.retestService.searchForm.value.retestYear != '' 
      && this.retestService.searchForm.value.retestYear != null){
      this.retestService.retestSearch.retestYear = this.retestService.searchForm.value.retestYear;
    }
    else {
      this.retestService.retestSearch.retestYear = '0';
    }

    if(this.retestService.searchForm.value.retestQuarter != '' 
      && this.retestService.searchForm.value.retestQuarter != null){
      this.retestService.retestSearch.retestQuarter = this.retestService.searchForm.value.retestQuarter;
    }
    else {
      this.retestService.retestSearch.retestQuarter = '0';
    }

    if(this.retestService.searchForm.value.tier != '' 
      && this.retestService.searchForm.value.tier != null){
      this.retestService.retestSearch.tier = this.retestService.searchForm.value.tier;
    }
    else {
      this.retestService.retestSearch.tier = '0';
    }
  }

  searchResults(): RetestSearch[] {
    return this.retestService.searchResults;
  }

}